var _defs, _circle, _polygon, _polygon2, _polygon3, _circle2, _polygon4, _polygon5, _polygon6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopRated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e8c6f7;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 550.05,
    y1: 794.62,
    x2: 742.94,
    y2: 794.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9a3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a1700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 273.91,
    y1: 794.62,
    x2: 466.8,
    y2: 794.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 214.58,
    y1: 453.72,
    x2: 811.35,
    y2: 453.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fa9d41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ec3f0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e92700"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 512,
    cy: 512,
    r: 512
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "550.05 708.04 639.52 924.04 671.42 852.81 742.94 881.2 653.47 665.2 550.05 708.04"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "466.8 708.04 377.33 924.04 345.42 852.81 273.91 881.2 363.38 665.2 466.8 708.04"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "512.97 181.82 560.23 155.33 596.99 195.13 650.12 184.54 672.78 233.75 726.59 240.1 732.93 293.9 782.14 316.56 771.55 369.7 811.35 406.46 784.86 453.72 811.35 500.98 771.55 537.74 782.14 590.87 732.93 613.53 726.59 667.34 672.78 673.69 650.12 722.9 596.99 712.31 560.23 752.11 512.97 725.61 465.71 752.11 428.95 712.31 375.81 722.9 353.15 673.69 299.35 667.34 293 613.53 243.79 590.87 254.38 537.74 214.58 500.98 241.07 453.72 214.58 406.46 254.38 369.7 243.79 316.56 293 293.9 299.35 240.1 353.15 233.75 375.81 184.54 428.95 195.13 465.71 155.33 512.97 181.82"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 512.97,
    cy: 453.72,
    r: 195.96
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "214.58 640.2 243.97 624.75 238.36 657.47 262.13 680.65 229.27 685.42 214.58 715.2 199.88 685.42 167.03 680.65 190.8 657.47 185.19 624.75 214.58 640.2"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "858.91 574.67 888.29 559.22 882.68 591.95 906.46 615.13 873.6 619.9 858.91 649.67 844.21 619.9 811.35 615.13 835.13 591.95 829.52 559.22 858.91 574.67"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "370.35 111.94 399.74 96.49 394.13 129.21 417.91 152.39 385.05 157.16 370.35 186.94 355.66 157.16 322.8 152.39 346.58 129.21 340.96 96.49 370.35 111.94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRated);
export default __webpack_public_path__ + "static/media/top-rated.3fda51a0ee80bdd01140098d7b92db16.svg";
export { ForwardRef as ReactComponent };